<script>
import adminTable from './mixins/adminTable'
export default
{

    mixins: [ adminTable ],

    data()
    {
        return {
            data: [],
            url: '/v1/admin/timetables',
            tableName: 'tableTimetable',
            emptyModel: { is_return:false, bus_route_id: null},
            columns: [ 'id', 'route', 'start', 'is_return', 'created_at', 'actions'],
            options: {
                headings: {
                    bus_route: this.$t('GENERAL.ROUTE'),
                    actions: this.$t('TABLE.ACTIONS'),
                    created_at: this.$t('GENERAL.CREATED_AT'),
                    is_return: this.$t('GENERAL.RETURN'),
                },
                perPage: 50,
                perPageValues: [10, 25, 50, 100, 200, 400],
                saveState: true,
                highlightMatches: true,
                filterByColumn: true,
                columnsDropdown: true,
                toMomentFormat: true,
            }
        }
    },
}
</script>

<template>
    <div class="container-fluid">
        <mv-modal ref="form">
            <span slot="header">{{ $t('GENERAL.EDIT') }}</span>
            <mv-timetable-form :model="model" :edit="formEdit" @save="saveForm"></mv-timetable-form>
            <div slot="footer">
                <button class="btn btn-success" @click="closeForm">{{ $t('GENERAL.CANCEL') }}</button>
                <button class="btn btn-primary" @click="saveForm">{{ $t('GENERAL.SAVE') }}</button>
            </div>
        </mv-modal>
        <div class="panel panel-primary">
            <div class="panel-heading">
                <div class="row">
                    <div class="col-sm-10">
                        <h4>{{ $t('MENU.TIMETABLE') }}</h4>
                    </div>

                    <div class="col-sm-2 text-right">
                        <button class="btn btn-xs btn-warning" @click="newModel">
                            <icon name="plus"></icon>
                        </button>
                    </div>
                </div>
            </div>
            <div class="panel-body">
                <v-client-table :data="data" :columns="columns" :options="options" :name="tableName" ref="table">
                    <div slot="actions" slot-scope="props" class="text-center">
                        <button class="btn btn-xs btn-warning" @click="delModel(props.row, props.row.name)">
                            <icon name="remove"></icon>
                        </button>
                        <button class="btn btn-xs btn-primary" @click="updateModel(props.row)">
                            <icon name="edit"></icon>
                        </button>
                    </div>
                    <div slot="route" slot-scope="props">
                        <div v-if="props.row.bus_route_id && props.row.bus_route && props.row.bus_route.name">
                            {{ props.row.bus_route.name }}
                        </div>
                    </div>
                    <div slot="is_return" slot-scope="props">
                        <icon name="check" v-if="props.row.is_return"></icon>
                    </div>
                </v-client-table>
            </div>
        </div>
    </div>
</template>


// WEBPACK FOOTER //
// src/pages/Timetable.vue